import React from 'react';

import {
  PageBlockStyles,
  type Maybe,
} from '@/components/common/Providers/GraphqlProvider/generated';

import CardDownloadParticipateStyleA from './CardDownloadParticipateStyleA';
import CardDownloadParticipateStyleB from './CardDownloadParticpateStyleB';

type Props = {
  title: string;
  publicationDate: string;
  expeditionDate: string;
  isFullScreen?: boolean;
  style: Maybe<PageBlockStyles> | undefined;
  description: string;
  downloadText: string | null | undefined;
  downloadLink: string | null | undefined;
  image: string | null | undefined;
};

const CardDownloadParticipate = ({
  title,
  publicationDate,
  expeditionDate,
  isFullScreen = true,
  style,
  description,
  downloadText,
  image,
  downloadLink,
}: Props) => {
  const isStyleA = style == PageBlockStyles.A;

  if (isStyleA) {
    return (
      <CardDownloadParticipateStyleA
        expeditionDate={expeditionDate}
        publicationDate={publicationDate}
        title={title}
        isFullScreen={isFullScreen}
        description={description}
        downloadText={downloadText}
        downloadLink={downloadLink}
      />
    );
  }

  return (
    <CardDownloadParticipateStyleB
      expeditionDate={expeditionDate}
      publicationDate={publicationDate}
      title={title}
      isFullScreen={isFullScreen}
      downloadLink={downloadLink}
      image={image}
    />
  );
};

export default CardDownloadParticipate;
